import { ROUTER_BASE_PATH } from '../constants';
import HeadMetaData from './HeadMetaData';
import { meta } from '../metaInfo';

const OpenAPIViewer = () => (
  <>
    <HeadMetaData
      title={meta.apiView.title}
      description={meta.apiView.description}
    />
    <elements-api
      apiDescriptionUrl={process.env.REACT_APP_SWAGGER_FILE_URL}
      router="history"
      basePath={ROUTER_BASE_PATH}
      layout="sidebar"
    />
  </>
);

export default OpenAPIViewer;
